import { Check as CheckIcon } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

import { PLAN_TEAMPERSEAT2 } from '@/constants/userSubscriptionPlans'
import { useUpgradePlan } from '../../hooks'
import { Buttons } from '../Buttons'
import { Features } from '../Features'
import { TEAM_AMOUNT, TEAM_PLAN_FEATURES } from './constants'
import css from './styles.module.css'

interface Props {
  activeIndex: number
  onSetActiveSlide: (index: number) => void
}

export const UpgradeToTeam: React.FC<Props> = ({
  activeIndex,
  onSetActiveSlide,
}) => {
  const { loading, handleClickAllPlan, handleUpgradePlan } = useUpgradePlan()

  return (
    <>
      <div className={css.pro_features_item}>
        <CheckIcon /> Everything from Pro
      </div>

      <Features
        activeSlide={activeIndex}
        items={TEAM_PLAN_FEATURES}
        onClick={onSetActiveSlide}
      />

      <div className={css.description}>
        Seat-based pricing based on number <br />
        of members in the team
      </div>

      <Buttons
        amount={TEAM_AMOUNT}
        loading={loading}
        onUpgradeClick={() => {
          handleUpgradePlan(PLAN_TEAMPERSEAT2)
        }}
        onAllPlansClick={handleClickAllPlan}
      />
    </>
  )
}
